<template>
    <div class="">
        <div class="w1200" v-show="isShow">
            <div class="head clearfix">
                <HT text="zxns" class="fl" style="margin-top:20px"></HT>
                <div class="fr bread clearfix">
                    <div class="fl" style="margin-right:15px;color: #064186">当前位置:</div>
                    <div class="fl">
                        <el-breadcrumb separator-class="el-icon-arrow-right">
                            <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
                            <el-breadcrumb-item :to="{ path: '/recruit/zpgw' }">招贤纳士</el-breadcrumb-item>
                        </el-breadcrumb>
                    </div>
                </div>
            </div>
            <!-- <ZPLIST :zpval="list" :router="zpgwxq" /> -->
            <div class="content clearfix" id="content">
                <div class="left fl" id="gw">
                    <h2 class="title">招聘岗位</h2>    
                    <ul class="zpgw">
                        <li v-for="(item) in gwlist" :key="item.id" @click="goToTop(item.id)">{{ item.text }}</li>
                    </ul>
                </div>
                <div class="right text fl">
                    <div class="zpxz" v-html="zpxz[0].text"></div>
                    <ul class="gwxq">
                        <li v-for="item in gwlist" :key="item.id" :id="'gwxq' + item.id">
                            <a :href="item.goto" target="_blank">
                                <div class="rightTitle">{{ item.text }}</div>
                                <div>
                                    <el-tag v-for="(tag,index) in item.fl" :key="index" color="#76bd25" style="color: #fff;margin:7px 10px 0px 0;">{{tag}}</el-tag>
                                </div>
                                <table>
                                    <tr>
                                        <td width="100">期望月薪:</td>
                                        <td width="200">{{ item.qwyx }}</td>
                                        <td width="100">工作地点:</td>
                                        <td width="200">{{ item.gzdd }}</td>
                                    </tr>
                                    <tr>
                                        <td width="100">工作性质:</td>
                                        <td width="200">{{ item.gzxz }}</td>
                                        <td width="100">工作经验:</td>
                                        <td width="200">{{ item.gzjj }}</td>
                                    </tr>
                                    <tr>
                                        <td width="100">最低学历:</td>
                                        <td width="200">{{ item.zdxl }}</td>
                                        <td width="100">招聘人数:</td>
                                        <td width="200">{{ item.zprs }}</td>
                                    </tr>
                                    <tr>
                                        <td width="100">招聘要求:</td>
                                        <td width="200" colspan="3">{{ item.zpyq }}</td>
                                    </tr>
                                    <tr>
                                        <td width="100" colspan="4">岗位职责:</td>
                                    </tr>
                                    <tr>
                                        <td width="200" colspan="4" v-html="item.gwzz"></td>
                                    </tr>
                                </table>
                            </a>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import HT from '@/components/h2.vue'
import { request } from '@/assets/utils/request'

export default {
    data() {
        return {
            list: [],
            isShow: true,
            zpgwxq: "zpgwxq",
            zpxz: [],
            gwlist:[]
        }
    },
    components: {
        HT
    },
    methods: {
        getList() {
            var that = this;
            request('/mocks/recruit/zpgw.json',{
                onSuccess(data) {
                    try {
                        data = JSON.parse(data)
                        that.list = data
                    } catch (e) {
                        that.list = [];
                    }
                }
            })
        },
        getZPXZ() {
            var that = this;
            request('/mocks/recruit/zpxz.json',{
                onSuccess(data) {
                    try {
                        data = JSON.parse(data)
                        that.zpxz = data
                    } catch (e) {
                        that.zpxz = [];
                    }
                }
            })
        },
        getgw() {
            var that = this;
            request('/mocks/recruit/zpgw.json',{
                onSuccess(data) {
                    try {
                        data = JSON.parse(data)
                        that.gwlist = data
                    } catch (e) {
                        that.gwlist = [];
                    }
                }
            })
        },
        gwposition() {
            var documentScrollTop = document.documentElement.scrollTop || document.body.scrollTop;
            var myTop = document.getElementById('content').offsetTop
            var gw = document.getElementById('gw')
            var gwT = gw.style.top.split('px')[0]
            var myHeight = document.getElementById('content').offsetHeight
            if(documentScrollTop>myTop && gwT <myHeight ){
                gw.style.top = (documentScrollTop  - myTop) + 150 + 'px'
            }else{
                gw.style.top = '40px'
            }
        },
        goToTop(query){
            document.getElementById('gwxq'+ query).scrollIntoView({block: "center", behavior: "smooth"})
        }
    },
    mounted() {
        this.getList();
        this.getZPXZ();
        this.getgw();
        window.addEventListener('scroll', this.gwposition, true)
    },
    destroyed() {
        window.removeEventListener('scroll', this.gwposition, true)
    }
}
</script>

<style scoped>
    .w1200{
        margin: 0 auto;
    }
    .bread{
        font-size: 14px;
        height: 20px;
        line-height: 20px;
        margin-top: 50px;
    }
    .el-breadcrumb{
        line-height: 20px;
    }
    .head{
        padding-bottom: 23px;
        border-bottom: 2px solid #134b8c;
    }
    .content{
        position: relative;
        padding-bottom: 150px;
        line-height: 36px;
        color: #666;
    }
    .content .left{
        position: absolute;
        left: 50px;
        top: 40px;
        border: 1px solid #aaa;
        box-shadow: 1px 2px 3px #ccc;
        z-index: 5;
    } 
    .content .zpxz{
        padding-left: 15px;
        margin-bottom: 30px;
        margin-top: 30px;
    }
    .content  .right.text{
        width: 800px;
        position: relative;
        left: 300px;
    }
    .content  .right.text table{
        margin-top: 15px;
    }
    #gw .title{
        width: 100%;
        text-align: center;
        padding: 15px 0;
        background: #76bd25;
        color: #fff;
    }
    .zpgw .left li{
        max-width: 150px;
    }
    .zpgw .left li,.zpgw .right li{
        padding: 15px;
        cursor: pointer;
        border-bottom: 1px solid #ccc;
        text-align: center;
        line-height: 24px;
        background: #fff;
    }
    .zpgw .right li{
        text-align: left;
        border-bottom: 0;
        margin-bottom: 15px;
    }
    .zpgw li:hover{
        box-shadow: 0px 0px 3px #aaa;
    }
    .rightTitle{
        border-bottom: 1px solid #999;
        font-size: 20px;
        padding: 10px;
        text-indent: 3px;
        font-weight: 700;
    }
    .gwxq a{
        text-decoration: none;
        color: #666;
    }
</style>

<style>
    .bread .el-breadcrumb__inner.is-link{
        color: #064186;
        font-weight: 500;
    }
    .bread .el-breadcrumb__item:last-child .el-breadcrumb__inner.is-link{
        color: #5bb62d;
    }
</style>